export const quizQuestions = [
  {
    id: 'q1',
    question: "Do you currently have renter's insurance?",
    options: [
      { id: 'yes', label: "Yes, I have it" },
      { id: 'no', label: "No, I don't have it" },
      { id: 'not_sure', label: "Not sure / Don't know what it covers" },
      { id: 'thought_landlord', label: "I thought my landlord's insurance covered me" }
    ]
  },
  {
    id: 'q2',
    question: "How much are your personal belongings worth?",
    subtext: "(Think: electronics, furniture, clothes, jewelry, sports equipment, etc.)",
    options: [
      { id: 'lt_10k', label: "Less than $10,000" },
      { id: '10k_25k', label: "$10,000 - $25,000" },
      { id: '25k_50k', label: "$25,000 - $50,000" },
      { id: '50k_plus', label: "$50,000+" },
      { id: 'no_idea', label: "No idea / Never thought about it" }
    ],
    educationalNote: "Most renters are surprised - the average apartment has $20K-30K in belongings!"
  },
  {
    id: 'q3',
    question: "What's most important to you about renter's insurance?",
    options: [
      { id: 'protect_stuff', label: "Protecting my stuff (theft, fire, water damage)" },
      { id: 'liability', label: "Liability coverage (if someone gets hurt in my apartment)" },
      { id: 'temp_housing', label: "Covering temporary housing (if my place becomes unlivable)" },
      { id: 'lowest_price', label: "Lowest possible price" },
      { id: 'understanding', label: "Understanding what I'm actually buying" }
    ]
  },
  {
    id: 'q4',
    question: "What best describes where you live?",
    options: [
      { id: 'large_complex', label: "Apartment (large complex)" },
      { id: 'small_apt', label: "Small apartment/duplex" },
      { id: 'house', label: "Rented house" },
      { id: 'condo', label: "Condo/townhome" },
      { id: 'temp', label: "Temporary housing / month-to-month" },
      { id: 'roommates', label: "Living with roommates" }
    ]
  },
  {
    id: 'q5',
    question: "What worries you most about NOT having renter's insurance?",
    options: [
      { id: 'fire', label: "Losing everything in a fire/disaster" },
      { id: 'lawsuit', label: "Someone getting hurt and suing me" },
      { id: 'landlord_req', label: "My landlord requiring it (lease requirement)" },
      { id: 'theft', label: "Theft/break-in" },
      { id: 'water', label: "Water damage from pipes/neighbors" },
      { id: 'nothing', label: "Honestly, nothing worries me" },
      { id: 'not_sure_enough', label: "I have it, but not sure it's enough" }
    ]
  }
];

export const rentAmountOptions = [
  { value: '<1000', label: 'Under $1,000' },
  { value: '1000-1500', label: '$1,000 - $1,500' },
  { value: '1500-2000', label: '$1,500 - $2,000' },
  { value: '2000-2500', label: '$2,000 - $2,500' },
  { value: '2500+', label: '$2,500+' }
];

export const bestTimeOptions = [
  { value: 'morning', label: 'Morning (8am - 12pm)' },
  { value: 'afternoon', label: 'Afternoon (12pm - 5pm)' },
  { value: 'evening', label: 'Evening (5pm - 8pm)' },
  { value: 'weekends', label: 'Weekends' }
];